<template>
    <b-row id="loader-v2" class="mb-0 p-0" role="status">
        <b-col class="p-0"> 
            <img class="spinner-logo"
            src='../../../assets/images/login/master_isotipo_VP.svg'
            style="margin:auto;"  alt="logo" />
        </b-col>
    </b-row>
</template>

<script>
export default {
    name: 'LoaderV2'
}
</script>

<style lang="scss">
    #loader-v2 {
    margin: 20px auto;
    z-index: 1;
    width: 60px;
    height: 60px;
    border-radius: 50%;
}
</style>